import { render, staticRenderFns } from "./PrestationsVisage.vue?vue&type=template&id=5abc49f1&"
import script from "./PrestationsVisage.vue?vue&type=script&lang=js&"
export * from "./PrestationsVisage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports